var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSportsGolf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 26.6666C26.4507 26.6666 31.6673 21.4499 31.6673 14.9999C31.6673 8.54992 26.4507 3.33325 20.0007 3.33325C13.5507 3.33325 8.33398 8.54992 8.33398 14.9999C8.33398 21.4499 13.5507 26.6666 20.0007 26.6666ZM20.0007 6.66659C24.6007 6.66659 28.334 10.3999 28.334 14.9999C28.334 19.5999 24.6007 23.3333 20.0007 23.3333C15.4007 23.3333 11.6673 19.5999 11.6673 14.9999C11.6673 10.3999 15.4007 6.66659 20.0007 6.66659Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 14.9998C17.5871 14.9998 18.3333 14.2536 18.3333 13.3332C18.3333 12.4127 17.5871 11.6665 16.6667 11.6665C15.7462 11.6665 15 12.4127 15 13.3332C15 14.2536 15.7462 14.9998 16.6667 14.9998Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3346 14.9998C24.2551 14.9998 25.0013 14.2536 25.0013 13.3332C25.0013 12.4127 24.2551 11.6665 23.3346 11.6665C22.4142 11.6665 21.668 12.4127 21.668 13.3332C21.668 14.2536 22.4142 14.9998 23.3346 14.9998Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 11.6666C20.9211 11.6666 21.6673 10.9204 21.6673 9.99992C21.6673 9.07944 20.9211 8.33325 20.0007 8.33325C19.0802 8.33325 18.334 9.07944 18.334 9.99992C18.334 10.9204 19.0802 11.6666 20.0007 11.6666Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 31.6666H15.0013C16.8346 31.6666 18.3346 33.1666 18.3346 34.9999V36.6666H21.668V34.9999C21.668 33.1666 23.168 31.6666 25.0013 31.6666H28.3346V28.3333H11.668V31.6666Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsGolf);
export default __webpack_public_path__ + "static/media/sports-golf.e8197bba60c6cc1c1bd570a08a552e0d.svg";
export { ForwardRef as ReactComponent };